export default {
  // flag indicating that the app is ready to display (configuration fetched, login done etc)
  initialized: false,
  ready: false,
  clientReady: false,
  proactiveTriggered: false,
  chatClientConnectionStatus: null,
  orgDomain: null,
  loginDomain: null,
  appId: null,
  orgId: null,
  _authError: null,
  _serverError: null,
};
